import { DatePicker } from '@/components/ui/date-picker';
import { Panel } from '@/components/ui/panel';

interface JobDatesCardProps {
  noticeDate: string | null | undefined;
  estimateSendDate: string | null | undefined;
  startDate: string | null | undefined;
  completedDate: string | null | undefined;
  onUpdateField: (field: string, value: string | null) => Promise<void>;
}

export function JobDatesCard({
  noticeDate,
  estimateSendDate,
  startDate,
  completedDate,
  onUpdateField,
}: JobDatesCardProps) {
  const formatDateForDb = (date: Date | undefined): string | null => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <Panel title="Important Dates" contentClassName="flex flex-col md:flex-row gap-4 md:gap-8">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span>📅</span>
            <label className="text-sm font-bold text-gray-700 uppercase">
              Notice Date
            </label>
          </div>
          <DatePicker
            value={noticeDate}
            onSave={(date) =>
              onUpdateField('noticeDate', formatDateForDb(date))
            }
            placeholder="Set date"
          />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span>📤</span>
            <label className="text-sm font-bold text-gray-700 uppercase">
              Estimate Sent Date
            </label>
          </div>
          <DatePicker
            value={estimateSendDate}
            onSave={(date) =>
              onUpdateField('estimateSendDate', formatDateForDb(date))
            }
            placeholder="Set date"
          />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span>🚧</span>
            <label className="text-sm font-bold text-gray-700 uppercase">
              Job Start Date
            </label>
          </div>
          <DatePicker
            value={startDate}
            onSave={(date) =>
              onUpdateField('startDate', formatDateForDb(date))
            }
            placeholder="Set date"
          />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span>🏁</span>
            <label className="text-xs font-bold text-gray-700 uppercase">
              Job Completed Date
            </label>
          </div>
          <DatePicker
            value={completedDate}
            onSave={(date) =>
              onUpdateField('completedDate', formatDateForDb(date))
            }
            placeholder="No date set"
          />
        </div>
    </Panel>
  );
}
